import { verifyVariable } from "./Functions";

export function toCurrency(value) {
    if (value !== null) {
        value = parseFloat(value);
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(value);
    } else {
        return null;
    }
};

export function formatIndicators(value) {
    if (value !== null) {
        let text = value.toString();
        return text.replace(".", ",")
    } else return null
}

export function toDecimal(value) {
    if (value !== null) {
        value = parseFloat(value);
        return new Intl.NumberFormat('pt-BR', {
            style: 'decimal',
            currency: 'BRL',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);

    } else {
        return null;
    }
};

export function toDecimalFormat(value) {
    if (value !== null) {
        value = parseFloat(value);
        return new Intl.NumberFormat('pt-BR', {
            style: 'decimal',
            currency: 'BRL',
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
        }).format(value);
    } else {
        return null;
    }
};
export function nonDecimalFormat(value) {
    if (value !== null) {
        value = parseFloat(value);
        if (Math.abs(value) > 10)
            return new Intl.NumberFormat('pt-BR', {
                style: 'decimal',
                currency: 'BRL',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(value);
        else return toDecimalFormat(value);
    } else {
        return null;
    }
};

export function toMillionFormat(value) {
    return toDecimal(value / 1000000);
}

export function toThousandsFormat(value) {
    return toDecimal(value / 1000);
}

export function formatTableLabel(value) {
    if (Math.abs(value) >= 1000000) {
        return toDecimal(value / 1000000) + 'M';
    }

    if (Math.abs(value) >= 1000) {
        return toDecimal(value / 1000) + 'k';
    }

    return toDecimal(value);
}

export function formatMoneyValue(value) {
    if (value)
        return "R$ ".concat(toDecimal(value))
    else
        return "R$ 0,00"
}
export function formatMoneyValueNonDecimal(value) {
    if (value)
        return "R$ ".concat(nonDecimalFormat(value))
    else
        return "R$ 0"
}

export function getStringPercent(value, total) {
    if (verifyVariable(value) && verifyVariable(total)) {
        value = Math.abs(value);
        let percent = (value / total) * 100;
        return percent.toFixed(2) + "%";
    }
    return "";
}

export function getNumberPercent(total) {
    if (verifyVariable(total)) {
        let percent = (total - 1) * 100;
        return Number(percent.toFixed(2));
    }
    return null

}

export function toPercent(decimalNumber) {
    if (decimalNumber == null || decimalNumber == undefined)
        return null
    else
        return (decimalNumber * 100).toFixed(2)
}

export function formatCEP(number) {
    if (verifyVariable(number)) {
        return number.replace(/^(\d{2})(\d{3})(\d{3})/, "$1.$2-$3");
    } else return null
}


export function formatPhoneNumber(phoneNumber) {
    let cleaned = ('' + phoneNumber).replace(/\D/g, '');

    if (phoneNumber?.includes('/ (')) {
        let formattedNumbers = phoneNumber?.split('/').map(number => {
            let cleanedNumber = number?.replace(/\s/g, '').replace(/\D/g, '');
            if (cleanedNumber?.length === 11) {
                return `(${cleanedNumber.slice(0, 2)}) ${cleanedNumber.slice(2, 3)} ${cleanedNumber.slice(3, 7)}-${cleanedNumber.slice(7)}`;
            } else if (cleanedNumber.length === 10) {
                return `(${cleanedNumber.slice(0, 2)}) ${cleanedNumber.slice(2, 6)}-${cleanedNumber.slice(6)}`;
            } else {
                return cleanedNumber;
            }
        });
        return formattedNumbers?.join(', ');
    } else {
        if (cleaned?.length === 11) {
            return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 3)} ${cleaned.slice(3, 7)}-${cleaned.slice(7)}`;
        } else if (cleaned.length === 10) {
            return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 6)}-${cleaned.slice(6)}`;
        } else {
            return phoneNumber;
        }
    }
}
